<template>
  <v-container>

    <v-layout row wrap justify-center>
      <v-flex xs12 sm6 md4 v-for="(item, index) in contenidos" :key="'button-expand'+index" class="expand-flex-container">
        <div class="button-expand-cont">
          <button @mouseover="showText(index, item)" @click="showText(index, item)" class="button-expand back-red hvr-grow">
            {{item.nombre}}
          </button>
          <div v-if="item.visto" class="expand-text light-dark-int animated fadeInDown">
            <p role="alert" v-html="item.texto"></p>
          </div>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    contenidos: {
      type: Array,
      required: true
    }
  },
  methods: {
    showText(event, arr) {
      arr.visto = true;
      var checkVistos = this.contenidos.every((elem) => {
        return elem.visto === true
      })
      if(checkVistos){
        this.$store.commit("nextShow", true);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.expand-flex-container{
  align-items: stretch;
}
.button-expand-cont {
  flex: 1 1;
  width: 100%;
  max-width: 300px;
  margin: auto;
  overflow: hidden;
  // height: 100%;  
  .button-expand {
    color: white;
    font-weight: bold;
    width: 100%;
    padding: 5px;
    border-radius: 8px 8px 0 0;
    z-index: 2;
    position: relative;
  }
  .expand-text {
    z-index: 1;
    position: relative;
    border: dashed 2px #aaa;
    border-radius: 0 0 8px 8px;
    padding: 10px;
    // height: 85%;
    // min-height: 300px;
  }
}
</style>





// WEBPACK FOOTER //
// ButtonExpandCont.vue?176943db